import { render, staticRenderFns } from "./total-invest.vue?vue&type=template&id=5ab2bd67&scoped=true"
import script from "./total-invest.vue?vue&type=script&lang=js"
export * from "./total-invest.vue?vue&type=script&lang=js"
import style0 from "./total-invest.vue?vue&type=style&index=0&id=5ab2bd67&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2bd67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab2bd67')) {
      api.createRecord('5ab2bd67', component.options)
    } else {
      api.reload('5ab2bd67', component.options)
    }
    module.hot.accept("./total-invest.vue?vue&type=template&id=5ab2bd67&scoped=true", function () {
      api.rerender('5ab2bd67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fin-form/total-invest.vue"
export default component.exports